<div class="entry-page-form">
    <h2 class="title">Log in to your account</h2>
    <p class="sub-title">
        Enter {{ isDefaultLoginType ? entityNames.EMAIL : entityNames.USERNAME }} and password to enter
    </p>
    <cm-login-form
        [isSubmitted]="isSubmitted"
        [errorMessage]="error"
        [loginType]="loginType"
        (submitForm)="onSubmit(loginForm)"
        (tokenLogin)="onTokenLogin($event)"
        #loginForm
    >
    </cm-login-form>
</div>
<cm-popup-corporate-website *ngIf="isPopupShown" (closeClick)="isPopupShown = false"> </cm-popup-corporate-website>
